<script setup lang="ts">
import { computed } from "vue";
import { Organization } from "../Data/Models/OrganizationModel.ts";
import { Team } from "../Data/Models/TeamModel.ts";
import { RouterLink } from "vue-router";

interface Props {
    /**
     * The currently chosen organization
     */
    org: Organization,

    /**
     * The currently selected team (if any)
     */
    team?: Team | null,

    /**
     * A list of workspaces that should be displayed in the sidebar
     */
    workspaces?: Array<Team>,

    /**
     * The current page route (example: org.dashboard)
     */
    curRoute?: string,

    /**
     * If true, the team selection buttons will be disabled
     * Used to prevent switching teams while data is loading
     */
    isLoading?: boolean,
}

//
// Props
const props = withDefaults(defineProps<Props>(), {
    workspaces: () => [],
    team: null,
    curRoute: "",
    isLoading: false,
});

//
// Computed
/**
 * Returns the slug of the current team
 */
const currentTeamSlug = computed(() => props.team?.slug || null);

/**
 * Returns the list of workspaces that should be displayed
 */
const teamsList = computed(() => {
    return [...props.workspaces].sort((d1: Team, d2: Team) => {
        return d1.created_at.unix() - d2.created_at.unix();
    });
});

/**
 * Returns a url that we can use to fetch the users photo
 */
const userPhotoUrl = computed(() => {
    return "/images/user.svg";
    // return _.get(this.user, "photo_url", "/images/user.svg");
});
</script>

<template>
  <div class="teams">
    <div class="teams-list">
      <!-- All Analytics Links -->
      <!-- <button -->
      <!--   :class="{ 'router-link-active': props.curRoute === 'org.dashboard' }" -->
      <!--   class="bg-inverse" -->
      <!--   type="button" -->
      <!--   @click="org.visit()" -->
      <!-- > -->
      <!--   <div class="link-body"> -->
      <!--     <i class="fa-solid fa-house fa-2x" /> -->
      <!--   </div> -->
      <!-- </button> -->

      <!-- Teams Links -->
      <button
        v-for="currentTeam in teamsList"
        :key="currentTeam.slug"
        :class="{ 'router-link-active': currentTeam.slug === currentTeamSlug }"
        type="button"
        :disabled="isLoading"
        @click="!isLoading && currentTeam.visit()"
      >
        <div
          v-if="currentTeam.abbreviation"
          :class="['_teamLink', `_abbv_${currentTeam.abbreviation}`]"
          class="link-body"
          :style="`background: ${currentTeam.color}`"
        >
          {{ currentTeam.abbreviation }}
        </div>
        <img
          v-else
          class="_personalTeam"
          :src="userPhotoUrl"
          style="object-fit: cover"
          height="35px"
          width="35px"
        >
      </button>

      <!-- Add New Team -->
      <!-- <a -->
      <!--   v-if="org.can('create_team')" -->
      <!--   href="javascript:void(0)" -->
      <!--   class="_createTeam bg-none" -->
      <!--   @click="showCreateTeamModal" -->
      <!-- > -->
      <!--   <div -->
      <!--     class="link-body" -->
      <!--     style="border: 1px dashed #ffffff" -->
      <!--   > -->
      <!--     <i class="fa-solid fa-plus fa-1x" /> -->
      <!--   </div> -->
      <!-- </a> -->

      <router-link
        v-if="org.can('view_org_settings')"
        :to="{
          name: 'org.settings.profile',
          params: { org: org.slug },
        }"
        class="bg-inverse"
      >
        <div class="_orgSettingsLink link-body">
          <i class="fa-solid fa-2x fa-sliders" />
        </div>
      </router-link>

      <!-- <router-link -->
      <!--   v-if="org.can('view_team_settings')" -->
      <!--   :to="{ -->
      <!--     name: 'org.settings.teams', -->
      <!--     params: { org: org.slug }, -->
      <!--   }" -->
      <!--   class="bg-inverse" -->
      <!-- > -->
      <!--   <div class="_teamSettingsLink link-body"> -->
      <!--     <i class="fa-solid fa-2x fa-gear" /> -->
      <!--   </div> -->
      <!-- </router-link> -->
      <!---->
      <!-- <router-link -->
      <!--   v-if="org.can('view_org_audit')" -->
      <!--   :to="{ -->
      <!--     name: 'org.audit', -->
      <!--     params: { org: org.slug }, -->
      <!--   }" -->
      <!--   class="bg-inverse" -->
      <!-- > -->
      <!--   <div class="_auditLink link-body"> -->
      <!--     <i class="fa-solid fa-2x fa-eye" /> -->
      <!--   </div> -->
      <!-- </router-link> -->
      <!---->
      <!-- <router-link -->
      <!--   :to="{ -->
      <!--     name: 'org.helpdesk', -->
      <!--     params: { org: org.slug }, -->
      <!--   }" -->
      <!--   class="_helpLink bg-inverse" -->
      <!-- > -->
      <!--   <div class="link-body"> -->
      <!--     <i class="fa-solid fa-2x fa-circle-question" /> -->
      <!--   </div> -->
      <!-- </router-link> -->
    </div>
  </div>
</template>
